<div cdkTrapFocus
     role="dialog"
     [attr.aria-modal]="true"
     [attr.aria-labelledby]="_dialogLabelId ?? undefined"
     [attr.mode]="datetimepicker.mode"
     class="mtx-datetimepicker-content-container">
  <mtx-calendar [id]="datetimepicker.id"
                [ngClass]="datetimepicker.panelClass"
                [attr.mode]="datetimepicker.mode"
                [type]="datetimepicker.type"
                [startAt]="datetimepicker.startAt"
                [startView]="datetimepicker.startView"
                [maxDate]="datetimepicker._maxDate"
                [minDate]="datetimepicker._minDate"
                [dateFilter]="datetimepicker._dateFilter"
                [multiYearSelector]="datetimepicker.multiYearSelector"
                [preventSameDateTimeSelection]="datetimepicker.preventSameDateTimeSelection"
                [timeInterval]="datetimepicker.timeInterval"
                [twelvehour]="datetimepicker.twelvehour"
                [selected]="datetimepicker._selected"
                [timeInput]="datetimepicker.timeInput"
                (selectedChange)="datetimepicker._select($event)"
                (viewChanged)="datetimepicker._viewChanged($event)"
                (_userSelection)="datetimepicker.close()"
                [@fadeInCalendar]="'enter'">
  </mtx-calendar>
</div>
